import { ready } from '../global/instantiate';
import { addGiftToCart } from '../sections/cart/addGiftToCart';
import { showShippingMessage } from '../sections/cart/showShippingMessage';
import { showFreeShippingBar } from '../sections/cart/showFreeShippingBar';

ready(() => {
  showShippingMessage();
  showFreeShippingBar();
  addGiftToCart();
})